import Vue from 'vue';
import { isTablet } from 'utils/general';
import on from 'dom-event';
import debounce from 'lodash.debounce';
import { trackEvent } from '../../assets/js/lib/tracking';

export default (el) =>
  new Vue({
    el,
    name: 'Best for',
    components: {
      accordion: () => import('../accordion/accordion.vue'),
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
    },
    data: {
      slideValue_1: '50',
      slideValue_2: '50',
      slideValue_3: '50',
      slideValue_4: '50',
      isTablet: isTablet(),
      activeIndex: 1,
    },
    mounted() {
      on(window, 'resize', debounce(this.onResize, 300));
    },
    methods: {
      setActivePhotos(index) {
        this.activeIndex = index;

        trackEvent({
          event: 'slider_interactions',
          click_action: 'select',
          image_index: index.toString(),
          component_name: this.$el.dataset.componentName,
          ...(this.$el.dataset.siteSection && {site_section: this.$el.dataset.siteSection})
        })
      },
      onResize() {
        this.isTablet = isTablet();
      },
      slideChange(index) {
        trackEvent({
          event: 'slider_interactions',
          click_action: 'swipe',
          image_index: index.toString(),
          component_name: this.$el.dataset.componentName,
          ...(this.$el.dataset.siteSection && {site_section: this.$el.dataset.siteSection})
        })
      },
      toggle(item) {
        trackEvent({
          event: 'accordion_interactions',
          click_action: item.isActive ? 'expand' : 'collapse',
          section_name: item.title.toLowerCase(),
          component_name: this.$el.dataset.componentName,
          ...(this.$el.dataset.siteSection && {site_section: this.$el.dataset.siteSection})
        })
      }
    },
  });
